import { ReactElement } from "react";
import { Modal, message, Form, Input, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import firebase from "firebase/app";
import { SET_LOADING_STATE, RESET_LOADING_STATE } from "../../redux/constants";

type Props = {
  visible: boolean;
  onClose: () => void;
  onDone: (uid: string) => void;
  user: any;
};

const { useForm } = Form;
const { Option } = Select;

export function EditUserModal({ visible, user, onClose, onDone }: Props): ReactElement {
  const dispatch = useDispatch()
  const [form] = useForm();

  const onFinish = (values: any) => {
    dispatch({ type: SET_LOADING_STATE });
    onClose();
    firebase.firestore().collection('users').doc(user.id)
      .update(values)
      .then(() => {
        onDone({ ...user, ...values });
        message.success("User has been updated successful!");
        dispatch({ type: RESET_LOADING_STATE });
      })
      .catch(e => {
        console.log(e);
        message.error("Oop! Something went wrong!");
        dispatch({ type: RESET_LOADING_STATE });
      })
  };
  const onFinishFailed = () => {
    console.log('On Finish Failed');
  }

  return (
    <Modal
      title="Edit User"
      centered
      visible={visible}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          fullName: user.fullName,
          email: user.email,
          phoneNumber: user.phoneNumber,
          gender: user.gender,
          instagram: user.instagram,
          role: user.role
        }}
      >
        <Form.Item
          label="User Name"
          name="fullName"
          rules={[{ required: true, message: 'Please input user name!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Please input user email!' },
            { type: "email", message: "Please input valid email address!" }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="phoneNumber"
        // rules={[
        //   { required: true, message: "Please input user phone number" }
        // ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Gender"
          name="gender"
        >
          <Select>
            <Option value="male">Male</Option>
            <Option value="female">Female</Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Instagram"
          name="instagram"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Role"
          name="role"
        >
          <Select>
            <Option value="regular">User</Option>
            <Option value="manager">Manager</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
